import React from "react";
import { Item, BoxItem } from "../types";

interface PrintLayoutProps {
  boxCount: number;
  boxItems: BoxItem[];
  kastLabel: string;
  getItemById: (id: string) => Item | undefined;
}

const PrintLayout: React.FC<PrintLayoutProps> = ({
  boxCount,
  boxItems,
  kastLabel,
  getItemById,
}) => {
  const getGridClass = (count: number) => {
    if (count === 12) return "print-grid-12";
    if (count === 24) return "print-grid-24";
    if (count === 36) return "print-grid-36";
    return "print-grid-12";
  };

  const gridClass = getGridClass(boxCount);

  return (
    <div className="print-container">
      {/* First page - Kast Grid */}
      <div className="print-page-1">
        <div className="print-header">{kastLabel} - Kast Layout</div>

        <div className={`print-grid ${gridClass}`}>
          {Array.from({ length: boxCount }, (_, index) => {
            const boxItem = boxItems.find((bi) => bi.boxIndex === index);
            const item = boxItem ? getItemById(boxItem.itemId) : null;

            return (
              <div
                key={index}
                className={`print-box ${item ? "has-item" : ""}`}
              >
                {item ? (
                  <>
                    <img src={item.thumbnail} alt={item.name} />
                    <div className="item-name">{item.name}</div>
                  </>
                ) : (
                  <div>Vak {index + 1}</div>
                )}
              </div>
            );
          })}
        </div>

        <div className="print-page-number">1</div>
      </div>

      {/* Second page - Selected Items List */}
      <div className="print-page-2">
        <div className="print-header">{kastLabel} - Geselecteerde Items</div>

        <div className="print-subheader">
          Overzicht van geselecteerde items en hun vakken
        </div>

        <div className="print-items-list">
          {boxItems.length === 0 ? (
            <p>Geen items geselecteerd</p>
          ) : (
            boxItems.map((boxItem) => {
              const item = getItemById(boxItem.itemId);
              if (!item) return null;

              return (
                <div
                  key={`${boxItem.itemId}-${boxItem.boxIndex}`}
                  className="print-item"
                >
                  <img src={item.thumbnail} alt={item.name} />
                  <div className="print-item-info">
                    <div className="print-item-name">{item.name}</div>
                    <div className="print-item-details">
                      Kleur: {item.color} | Prijs: €{item.price.toFixed(2)} |
                      <span className="print-item-box">
                        {" "}
                        Vak: {boxItem.boxIndex + 1}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="print-page-number">2</div>
      </div>
    </div>
  );
};

export default PrintLayout;
